import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.string.includes";
import _toConsumableArray from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import tim from '../../tim';
var groupModules = {
  namespaced: true,
  state: {
    groupList: [],
    currentMemberList: [],
    createGroupModelVisible: false
  },
  getters: {
    hasGroupList: function hasGroupList(state) {
      return state.groupList.length > 0;
    }
  },
  mutations: {
    updateGroupList: function updateGroupList(state, groupList) {
      state.groupList = groupList;
    },
    updateCreateGroupModelVisible: function updateCreateGroupModelVisible(state, visible) {
      state.createGroupModelVisible = visible;
    },
    updateCurrentMemberList: function updateCurrentMemberList(state, memberList) {
      state.currentMemberList = [].concat(_toConsumableArray(state.currentMemberList), _toConsumableArray(memberList));
    },
    deleteGroupMemeber: function deleteGroupMemeber(state, userID) {
      state.currentMemberList = state.currentMemberList.filter(function (member) {
        return member.userID !== userID;
      });
    },
    deleteGroupMemberList: function deleteGroupMemberList(state, userIDList) {
      state.currentMemberList = state.currentMemberList.filter(function (member) {
        return !userIDList.includes(member.userID);
      });
    },
    resetCurrentMemberList: function resetCurrentMemberList(state) {
      state.currentMemberList = [];
    },
    reset: function reset(state) {
      Object.assign(state, {
        groupList: [],
        currentMemberList: [],
        createGroupModelVisible: false
      });
    }
  },
  actions: {
    updateGroupList: function updateGroupList(context, groupList) {
      context.commit('updateGroupList', groupList);
    },
    getGroupMemberList: function getGroupMemberList(context, groupID) {
      return tim.getGroupMemberList({
        groupID: groupID,
        offset: context.state.currentMemberList.length,
        count: 30
      }).then(function (imResponse) {
        context.commit('updateCurrentMemberList', imResponse.data.memberList);
        return imResponse;
      });
    }
  }
};
export default groupModules;